import SectionHeading from '../shared/SectionHeading';
import { TEXT_STYLES, BORDER_STYLES } from '../../constants/styles';

function ProjectDesignProcess({ title = 'Let\'s build this!', paragraphs = [], image }) {
  if (!paragraphs || paragraphs.length === 0) return null;

  return (
    <div className="max-w-3xl mx-auto space-y-6 mb-16 scroll-mt-32">
      <div className="prose prose-lg">
        {title && <SectionHeading>{title}</SectionHeading>}
        {paragraphs.map((paragraph, index) => (
          <p 
            key={index}
            className={`${TEXT_STYLES.body} ${index < paragraphs.length - 1 ? 'mb-6' : ''}`}
          >
            {paragraph}
          </p>
        ))}
        {image && (
          <div className="mt-6">
            <img
              src={image}
              alt={title}
              className={`w-full h-auto ${BORDER_STYLES.rounded}`}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectDesignProcess;
